._noFields_12jm9_1 {
  text-align: center;
  padding: 8px;
}
._noFields_12jm9_1 > span {
  font-size: 14px !important;
}